import { RegisterOptions } from 'react-hook-form';

export const emailValidationRule: RegisterOptions = {
  required: 'Email is required.',
  pattern: {
    value:
      /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/,
    message: 'Enter a valid email address.',
  },
};

export const usernameValidationRule: RegisterOptions = {
  required: 'Username is required.',
  minLength: {
    value: 2,
    message: 'Username must be minimum 2 characters long',
  },
  pattern: {
    value: /^[a-zA-Z0-9\-_.]+$/,
    message: 'Username is invalid. Please use only letters, numbers, underscores (_), dashes (-) and dots (.)',
  },
};

export const userGroupValidationRule: RegisterOptions = {
  required: true,
  validate: {
    isValidRole: (role: string): boolean | string => {
      const validRoles = new Set([
        'testers',
        'tester',
        'qa',
        'tester / qa',
        'tester/qa',
        'developers',
        'developer',
        'platform engineer',
        'platform engineers',
        'admins',
        'admin',
        'owner',
        'owners',
        'everyone',
        'all',
        'team',
      ]);

      return validRoles.has(role.toLowerCase()) || 'Invalid role.';
    },
  },
};

export const WorkspaceNameIsRequired = 'A name is required.';
export const WorkspaceNameIsTooShortErrorMessage = 'Workspace name must be at least 2 characters';
export const WorkspaceNameIsTooLongErrorMessage = 'Workspace name cannot be longer than 40 characters';
export const WorkspaceNameIsAlreadyInUseErrorMessage = 'Workspace name is already in use';
export const workspaceNameValidationRule: RegisterOptions = {
  required: WorkspaceNameIsRequired,
  minLength: { value: 2, message: WorkspaceNameIsTooShortErrorMessage },
  maxLength: { value: 40, message: WorkspaceNameIsTooLongErrorMessage },
};

export const tokenNameValidationRule: RegisterOptions = {
  required: 'Name is required',
  pattern: {
    value: /^[a-zA-Z0-9\-_. ]+$/,
    message: 'Token name is invalid. Please use only letters, numbers, underscores (_), dashes (-) and dots (.)',
  },
};

export const urlValidationRule: RegisterOptions = {
  required: true,
  validate(value: string): boolean | string {
    try {
      const url = new URL(value);
      return /^https?:$/g.test(url.protocol) || 'Invalid URL';
    } catch {
      return 'Invalid URL';
    }
  },
};
